/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FrequencyViewModel } from './FrequencyViewModel'; 

export function getFrequenciesInEffectForOrderOptions(orderId: string, onSuccess?: (result: FrequencyViewModel[]) => void) {
	return queryOptions({
		queryKey: ['frequencies-in-effect-for-order', orderId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/frequencies/queries/getfrequenciesineffectfororder/' + orderId;
			const resp = await axios.get<FrequencyViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(orderId)
	});
}